import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="registration-form"
export default class extends Controller {
  static targets = ["firstName", "lastName", "password", "passwordConfirmation", "submitButton"]
  
  connect() {
    // Initial validation
    this.validateForm()
  }
  
  validateForm() {
    const firstName = this.firstNameTarget.value.trim()
    const lastName = this.lastNameTarget.value.trim()
    const password = this.passwordTarget.value
    const passwordConfirmation = this.passwordConfirmationTarget.value
    const submitButton = this.submitButtonTarget
    
    // Check if names are provided
    const namesValid = firstName.length > 0 && lastName.length > 0
    
    // Check if both password fields have values and they match
    const passwordsValid = password && 
                          passwordConfirmation && 
                          password === passwordConfirmation && 
                          password.length >= 6
    
    // All fields must be valid
    const formValid = namesValid && passwordsValid
    
    // Update button state based on validation
    submitButton.disabled = !formValid
    
    // Update visual styles based on validation state
    if (formValid) {
      submitButton.classList.remove('opacity-50', 'cursor-not-allowed')
      submitButton.classList.add('cursor-pointer')
    } else {
      submitButton.classList.add('opacity-50', 'cursor-not-allowed')
      submitButton.classList.remove('cursor-pointer')
    }
    
    // Log validation state for debugging
    console.log({
      firstName,
      lastName,
      password,
      passwordConfirmation,
      namesValid,
      passwordsValid,
      formValid,
      buttonDisabled: submitButton.disabled
    })
  }
}
